// SPDX-FileCopyrightText: 2025 Land Baden-Württemberg <InnoLab@stm.bwl.de>
//
// SPDX-License-Identifier: MPL-2.0

import i18next from 'i18next';
import de from '../public/locales/de/translation.json';
import en from '../public/locales/en/translation.json';

export const SUPPORTED_LANGUAGES = [
  { code: 'de', name: 'Deutsch' },
  { code: 'en', name: 'English' },
];

export const DEFAULT_LANGUAGE = 'de';

const savedLanguage = localStorage.getItem('language') || DEFAULT_LANGUAGE;

// Kein await nötig, da die Ressourcen direkt als JS-Objekte übergeben werden (kein async Loading)
i18next.init({
  lng: savedLanguage,
  fallbackLng: DEFAULT_LANGUAGE,
  resources: {
    de: { translation: de },
    en: { translation: en },
  },
  interpolation: {
    escapeValue: false,
  },
});

export { i18next as i18n };
